'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var nthBitHeader = require('@narvar/nth-bit-header');
var Paragraph = require('@narvar/nth-bit-paragraph');
var PanelContentHeader_module = require('./PanelContentHeader.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);

const PanelContentHeader = ({
  as,
  icon,
  headerText,
  paragraphChildren,
  featureName,
  isLandscape = false,
  headerTextRole
}) => isLandscape ? /*#__PURE__*/React__default["default"].createElement("div", {
  className: clsx__default["default"]({
    [PanelContentHeader_module["default"].tableCell]: true,
    [PanelContentHeader_module["default"].alignLeft]: true
  })
}, /*#__PURE__*/React__default["default"].createElement("div", {
  className: PanelContentHeader_module["default"].tableCell
}, icon), /*#__PURE__*/React__default["default"].createElement("div", {
  className: PanelContentHeader_module["default"].tableCell,
  style: {
    padding: icon ? '0 1rem' : '0 1rem 0 0'
  }
}, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
  as: as,
  featureName: featureName,
  headerTextRole: headerTextRole
}, headerText), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
  featureName: featureName,
  containerCustomStyle: {
    margin: '0.25rem 0 0 0'
  }
}, paragraphChildren))) : /*#__PURE__*/React__default["default"].createElement("div", {
  className: PanelContentHeader_module["default"].alignCenter
}, icon, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
  as: as,
  headerTextRole: headerTextRole,
  featureName: featureName,
  containerCustomStyle: {
    margin: '1rem 0 0.5rem 0'
  }
}, headerText), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
  featureName: featureName,
  containerCustomStyle: {
    margin: 0
  }
}, paragraphChildren));

exports["default"] = PanelContentHeader;
